<template>
  <div class="license-file q-pa-md shadow3 bg-graph-8 relative-position">
    <div v-if="file">
      <Grid gaf="column" justify-content="space-between" align-items="center">
        <div class="card-title text-body-1 text-white-1">License file</div>
        <TrashIcon v-if="deletable" @click.native="$emit('delete')" />
      </Grid>

      <Grid gtr="1fr auto auto">
        <Grid class="cursor-pointer" justify-items="center" @click.native="download">
          <LmTooltip anchor="top middle" self="bottom middle">
            <div class="text-body-1">Click to download the file</div>
          </LmTooltip>

          <FileIcon />

          <div class="text-heading-3 text-white-1 q-mt-md text-center">{{ file.name }}</div>
        </Grid>

        <div class="line"></div>

        <Grid gaf="column" justify-content="space-between">
          <div class="text-body-1 text-white-1">Uploaded by: {{ file.created_by.name }}</div>
          <div class="text-body-1 text-white-1">On: {{ formatDateForCustomDisplay(file.created_at, 'D MMMM Y') }}</div>
        </Grid>
      </Grid>
    </div>

    <Grid
      v-else
      justify-content="center"
      align-items="center"
      justify-items="center"
      align-content="center"
      class="full-height"
    >
      <FileIcon />

      <div class="text-body-3 text-white-1">No license file</div>
    </Grid>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import FileIcon from '@/ui/icons/FileIcon'
import TrashIcon from '@/ui/icons/TrashIcon'

export default {
  components: {
    FileIcon,
    TrashIcon
  },

  props: {
    file: Object,
    deletable: Boolean
  },

  methods: {
    download() {
      apiTo.DOWNLOAD_MEDIA(this.file.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.license-file {
  border-radius: 2px;

  ::v-deep svg > path {
    fill: var(--r-white-1);
  }

  .line {
    height: 1px;
    background: var(--r-white-1);
    margin: var(--r-space-md) 0;
  }
}
</style>
